<template>
  <a ref="category"
     class="catalog-item"
     :href="link"
     @click="handleRedirect($event, link)">
    <span class="catalog-item__icon">
      <img :src="thumb" :alt="name" />
    </span>
    <div class="catalog-item__name">
      <span class="catalog-item__text">{{ name }}</span>
    </div>
  </a>
</template>

<script>
import { transliteration } from '../../../mixins/transliteration'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'CatalogSliderItem',
  mixins: [transliteration],
  props: {
    blockName: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    thumb: {
      type: [String, Boolean],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    position: {
      type: Number,
      default: null
    }
  },
  methods: {
    async handleRedirect (e, link) {
      e.preventDefault()

      await GoogleTagManagerService.promotionClickEvent({
        analyticsData: [
          {
            'name': this.transliterate(this.name),
            'creative': this.transliterate(this.blockName),
            'position': 'slot' + this.position
          }
        ],
        params: {
          'event': 'promotionClick'
        }
      })

      location.href = link
    }
  },
  mounted () {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // GoogleTagManagerService.promotionViewEvent({
        //   analyticsData: [
        //     {
        //       'name': this.transliterate(this.name),
        //       'creative': this.transliterate(this.blockName),
        //       'position': 'slot' + this.position
        //     }
        //   ]
        // })

        observer.unobserve(this.$refs.category)
      }
    })
    setTimeout(() => {
      observer.observe(this.$refs.category)
    }, 0)
  }
}
</script>

<style scoped lang="sass">

// catalog item
.catalog-item
  display: flex
  justify-content: center
  align-items: center
  flex-flow: column
  padding: 10px
  background-color: #f8f8f8
  border-radius: 5px

  +mmin($tablet)
    align-items: center
    padding: 20px

.catalog-item__icon
  width: 30px

  +mmin($tablet)
    width: 34px

  img
    width: 30px
    height: 30px
    display: block
    max-width: 30px
    margin: 0 auto
    object-fit: contain

    +mmin($tablet)
      width: 34px
      max-width: 34px

.catalog-item__name
  position: relative
  display: flex
  width: 100%
  height: 28px
  margin-top: 10px
  overflow: hidden
  align-items: center
  justify-content: center
  text-align: center

  +mmin($tablet)
    height: 36px
    margin-top: 15px
    align-items: center
    justify-content: center
    text-align: center

.catalog-item__text
  display: -webkit-box
  -webkit-line-clamp: 2
  -webkit-box-orient: vertical
  text-overflow: ellipsis
  font-size: 11px
  font-weight: 400
  color: $text-color

  +mmin($tablet)
    position: absolute
    top: 50%
    transform: translateY(-50%)
    font-size: 14px
    font-weight: 500
</style>
